import {Directive, HostListener, Input} from '@angular/core';

@Directive({
  selector: '[appNumber]',
})
export class NumberTypeDirective {
  @Input() appNumber: boolean;

  @HostListener('keypress', ['$event']) onKeyPress(event) {
    if (this.appNumber) {
      const charCode = event.key;
      const fieldValue = event.target.value;
      const numberRegex = new RegExp(`^[0-9]+$`);
      if (!fieldValue || numberRegex.test(fieldValue)) {
        if (!numberRegex.test(charCode)) {
          event.preventDefault();
        } else {
          return true;
        }
      } else {
        event.target.value = fieldValue.length ? Math.trunc(event.target.value) : fieldValue;
      }
      return true;
    }
  }
}
